import { render, staticRenderFns } from "./DisciplineCustomField.vue?vue&type=template&id=25db5d30&"
import script from "./DisciplineCustomField.vue?vue&type=script&lang=ts&"
export * from "./DisciplineCustomField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports